import Phaser from 'phaser';
import { EndingScene } from './game/EndingScene';
import { LevelMapScene } from './game/LevelMapScene';
import { LevelScene } from './game/LevelScene';
import { MenuScene } from './game/MenuScene';
import { PowerUpsScene } from './game/PowerUpsScene';
import { RosterScene } from './game/RosterScene';
import { TeamPickerScene } from './game/TeamPickerScene';
import { TutorialOverlay } from './game/TutorialOverlay';
import { WorldClearScene } from './game/WorldClearScene';
import { mountPasscodeGate } from './passcodeGate';

function startGame() {
  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent: 'app',
    backgroundColor: '#0a0f1f',
    scale: {
      mode: Phaser.Scale.RESIZE,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: window.innerWidth,
      height: window.innerHeight,
    },
    scene: [
      MenuScene,
      LevelMapScene,
      RosterScene,
      TeamPickerScene,
      LevelScene,
      TutorialOverlay,
      WorldClearScene,
      EndingScene,
      PowerUpsScene,
    ],
  });

  const refreshScale = () => {
    game.scale.refresh();
  };
  window.addEventListener('orientationchange', () => {
    setTimeout(refreshScale, 200);
    setTimeout(refreshScale, 600);
  });
  window.addEventListener('resize', refreshScale);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      setTimeout(refreshScale, 120);
    }
  });
}

mountPasscodeGate(startGame);
